import { SET_STUDENT_CLASSES } from './student-classes-actions';

// map of student ids to class ids
const initialState = {};

/**
 * StudentClasses Reducer
 *
 * Consumes SET_STUDENT_CLASSES action
 *
 * @param {object} the current state; may be undefined when application starts
 * @param {object} action, an object with a type and a payload
 * @returns {object} - new state
 */
export default function(state = initialState, action) {
    if (!action) return state;

    switch (action.type) {
        case SET_STUDENT_CLASSES:
            return action.payload;

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./containers/participation/all-classes/student-classes/student-classes-reducer.js